import post from './methods/post';

export default {
	request: (body, headers) => post('account/request', body, headers),
};
